<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_10.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">1、</div>
				<div class="step_txt">
					拧开收集器管盖，将采集样本后的拭子立即置于收集器中，将拭子头紧贴收集管底部和侧面，旋转拭子10次（至少30秒）。
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_11.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">2、</div>
				<div class="step_txt">
					用手隔着收集器外壁将拭子头液体挤干后，将拭子弃去，盖上收集器管盖后掰断顶端。
				</div>
			</div>
			
			<div class="step_el" style="padding-top:1.1rem;text-align: center;">
				<van-image
				  width="70%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_12.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">3、</div>
				<div class="step_txt">
					<div style="text-align: left;">
						拆开铝塑袋包装，取出检测卡放置在干净的平面上。轻轻挤压收集器滴加3滴样本到检测卡的加样孔。
					</div>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<!-- <van-button
				type="primary"
				block
				color="#4f56fe"
				@click="goStepFive"
			>
				下一步
			</van-button> -->
			<van-button
				type="primary"
				block
				color="#4f56fe"
				ref="toggle1"
				@click="goCountDown"
			>
				自检开始
			</van-button>
			<div style="padding-top: 0.2rem;text-align: center;font-size: 0.38rem;color: #E74A4A;">滴加样本5秒内点击按钮</div>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			noSleep: null,  //屏幕常亮对象
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			//监听屏幕常亮事件
			that.noSleep = new NoSleep();
			that.$refs.toggle1.addEventListener('click', function() {
				that.noSleep.enable();  //开启常亮
				//sessionStorage.setItem('isOnce', 'false');
			}, false);
			//微信分享
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		/* goStepFive() {
			this.$router.push({path:'/stepfive'});
		}, */
		goCountDown() {
			this.$router.push({path:'/countdown', query: {type: '10'}});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100vh;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}

.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{
	padding:0rem 0.9rem 1.107rem 0.9rem;
}
.step_box img, .btn_box img{width: 100%;}

.step_txt .txt_note{
	padding-top: 0.64rem;
	color: #720000;
	font-weight: bold;
}
.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}


>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

@media screen and (min-device-width : 768px){
	.btn_box{
		/* position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem; */
	}
} 
</style>
